/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-24 18:58:17
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2026-01-23 12:25:26
 * @FilePath: \mpc-monorepo\features\mpc-common\src\components\SForm\SFormElementWrapper\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {useState, useEffect, useRef, useMemo, forwardRef} from 'react'
import { useMemoizedFn } from 'ahooks'
import _ from 'lodash'
import classNames from 'classnames/bind'
import styles from './index.less'

const cx = classNames.bind(styles)

export type ElementWrapperProps = {
  changeInterceptor?: (value: any, oldValue: any) => Promise<any>, // 变更拦截器
  value?: any,
  onChange?: (value: any) => void
  children?: React.ReactElement,
  beforeSlot?: (value: any, props: any) => React.ReactElement | null,
  afterSlot?: (value: any, props: any) => React.ReactElement | null,
}

/**
 * 封装插槽组件，支持在子元素前后添加插槽（beforeSlot 和 afterSlot）
 * 同时对外暴露 onChange 和 value 属性，保证数据同步
 * 
 * @description
 * - beforeSlot 和 afterSlot 支持 ReactElement 或函数形式
 * - 函数形式会接收 (value, props) 作为参数
 * - 当 needValueAndOnChange 为 true 时，会将 value 和 onChange 传递给子组件
 * - 如果子组件已有 onChange，会合并调用（先调用子组件的，再调用传入的）
 */
export const SlotComponent = React.forwardRef<any, { 
  children: React.ReactNode | null, 
  beforeSlot?: React.ReactElement | null | ((value: any, props: any) => React.ReactElement | null), 
  afterSlot?: React.ReactElement | null | ((value: any, props: any) => React.ReactElement | null), 
  needValueAndOnChange?: boolean,
  onChange?: (value: any) => void, 
  value?: any 
}>(({ children, beforeSlot, afterSlot, needValueAndOnChange = true, onChange, value }, ref) => {
  // 判断是否是单个有效的 React 元素
  // 只有单个元素时才能安全地进行 cloneElement 操作
  const isSingleReactElement = React.isValidElement(children) && React.Children.count(children) === 1;

  // 获取子组件原有的 props（仅在单个元素时获取，避免类型错误）
  const childOriginalProps = isSingleReactElement ? (children as React.ReactElement).props : {};
  const childOriginalOnChange = childOriginalProps?.onChange;

  // 构建要传递给子组件的属性
  // 注意：ref 只传递给子组件，不传递给插槽函数
  const cloneProps: Record<string, any> = { ref };
  
  // 当需要传递 value 和 onChange 时，进行属性合并
  if (needValueAndOnChange) {
    // 传递 value 属性
    cloneProps.value = value;
    
    // 处理 onChange 合并逻辑
    if (childOriginalOnChange && onChange) {
      // 如果子组件已有 onChange，则合并两个 onChange
      // 先调用子组件的 onChange（保证子组件内部逻辑先执行）
      // 再调用传入的 onChange（保证外部状态同步）
      // 使用 try-catch 确保即使子组件 onChange 抛出异常，外部 onChange 也能执行
      cloneProps.onChange = (val: any) => {
        try {
          childOriginalOnChange(val);
        } catch (error) {
          // 子组件 onChange 出错时记录错误，但不阻止外部 onChange 执行
          console.error('SlotComponent: 子组件 onChange 执行出错', error);
        }
        // 无论子组件 onChange 是否成功，都执行外部 onChange
        onChange(val);
      };
    } else {
      // 如果只有一个 onChange，直接使用（优先使用传入的 onChange）
      cloneProps.onChange = onChange || childOriginalOnChange;
    }
  }

  // 处理插槽节点
  // 如果是函数则调用，传入 value 和 props（不包含 ref）
  // 如果是 ReactElement 则直接使用
  let beforeSlotNode: React.ReactElement | null = null;
  let afterSlotNode: React.ReactElement | null = null;
  
  try {
    if (beforeSlot) {
      // 传递给插槽函数的 props 不包含 ref，避免 ref 传递问题
      const slotProps = { ...cloneProps };
      delete slotProps.ref;
      beforeSlotNode = typeof beforeSlot === 'function' ? beforeSlot(value, slotProps) : beforeSlot;
    }
  } catch (error) {
    console.error('SlotComponent: beforeSlot 执行出错', error);
    beforeSlotNode = null;
  }
  
  try {
    if (afterSlot) {
      // 传递给插槽函数的 props 不包含 ref，避免 ref 传递问题
      const slotProps = { ...cloneProps };
      delete slotProps.ref;
      afterSlotNode = typeof afterSlot === 'function' ? afterSlot(value, slotProps) : afterSlot;
    }
  } catch (error) {
    console.error('SlotComponent: afterSlot 执行出错', error);
    afterSlotNode = null;
  }

  // 如果上下插槽都没有，则不包裹额外的 div，直接返回子元素
  // 这样可以避免不必要的 DOM 嵌套，提升性能
  if (!beforeSlotNode && !afterSlotNode) {
    // 只有单个 React 元素时才进行 cloneElement（需要传递 props）
    // 否则直接渲染（可能是文本、多个元素等）
    if (isSingleReactElement) {
      return <>{React.cloneElement(children as React.ReactElement, cloneProps)}</>;
    }
    return <>{children}</>;
  }
  
  // 有插槽时，需要包裹 div 来布局
  return (
    <div className="s-form-slot-component">
      {beforeSlotNode}
      <div className="slot-component-content">
        {/* 只有单个 React 元素时才进行 cloneElement，否则直接渲染 */}
        {isSingleReactElement ? React.cloneElement(children as React.ReactElement, cloneProps) : children}
      </div>
      {afterSlotNode}
    </div>
  );
});

SlotComponent.displayName = 'SlotComponent';

const SFormElementWrapper = forwardRef(function (props: ElementWrapperProps, parentRef) {
  const {value, onChange,children,
    changeInterceptor,
    beforeSlot,
    afterSlot,
    ...resProps} = props
  const [localValue, setLocalValue] = useState(value)
  const [childValue, setChildValue] = useState(value)

  // 使用 useMemoizedFn 稳定引用，避免因 changeInterceptor/onChange 引用变化导致重绘
  const changeInterceptorFn = useMemoizedFn((val: any, oldVal: any) =>
    changeInterceptor ? changeInterceptor(val, oldVal) : Promise.resolve(val)
  )
  const onChangeFn = useMemoizedFn((val: any) => onChange?.(val))

  // 对比子组件的值，本地值，和外部值，保持一致
  useEffect(() => {
    if (!changeInterceptor) return;
    if (!_.isEqual(value, localValue)) {
      setLocalValue(value)
      setChildValue(value)
    } else if (!_.isEqual(childValue, localValue)) {
      if (!changeInterceptor) {
        setLocalValue(childValue)
        onChangeFn(childValue)
      } else {
        // 如果有拦截器，就先拦截，然后再设置值
        Promise.resolve(changeInterceptorFn(childValue, localValue)).then((newValue: any) => {
          setLocalValue(newValue)
          setChildValue(newValue)
          onChangeFn(newValue)
        }).catch(() => {
          setChildValue(localValue)
        })
      }
    }
  }, [value, localValue, childValue, changeInterceptor, changeInterceptorFn, onChangeFn])

  const result = useMemo(() => {
    if(changeInterceptor) {
      return {
        value: childValue,
        onChange: setChildValue
      }
    } else {
      return {
        value: value,
        onChange: onChangeFn
      }
    }
  }, [changeInterceptor, childValue, value, onChangeFn])

  const beforeSlotNode = beforeSlot?.(value, props)
  const afterSlotNode = afterSlot?.(value, props)

  // 判断子组件是否需要 value 和 onChange 属性
  // 只有当子组件已经声明了这些属性时，才传递（避免对不支持这些属性的组件强制传递）
  const childProps = React.isValidElement(children) ? (children.props as Record<string, any>) : resProps;

  // 构建要传递给子组件的属性（value/onChange 放最后，避免被 childProps 覆盖，确保 changeInterceptor 生效）
  const cloneProps: any = {
    ref: parentRef,
    ...childProps,
    value: result.value,
    onChange: result.onChange,
  };

  return <SlotComponent beforeSlot={beforeSlotNode} afterSlot={afterSlotNode} needValueAndOnChange={false}>
    {React.cloneElement(children, cloneProps)}
  </SlotComponent>
})


export default SFormElementWrapper